module.exports = __webpack_public_path__ + "static/media/lassens.88daeaa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/lassens.png
// module id = 243
// module chunks = 0